import { createTheme } from "@mantine/core";

export const theme = createTheme({
  primaryColor: "indigo",
  fontFamily:
    "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Helvetica Neue', sans-serif",
  defaultRadius: "md",
  components: {
    Paper: {
      defaultProps: { withBorder: true, radius: "md", p: "md" },
    },
    Button: {
      defaultProps: { radius: "md" },
    },
  },
});
